//require('./bootstrap');

window.Alpine = Alpine;

Alpine.start();

global.$ = global.jQuery = require('jquery');

import Alpine from 'alpinejs';
import 'tw-elements';
import jszip from 'jszip';
import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-fixedcolumns-dt';
import 'datatables.net-fixedheader-dt';
/*
import AOS  from 'aos';
*/
document.addEventListener("DOMContentLoaded", function() {
	//AOS.init();
    
    new DataTable('.datatableTable', {
        //scrollX: "100%",
        //scrollXInner: "150%",
        //scrollCollapse: true,
        paging: true,
        searching: true,
        pageLength: 50,
        //fixedHeader: true,
        fixedColumns:{left:1},
        columnDefs: function(){
            return [
                {
                    targets: "_all",
                    render: $.fn.dataTable.render.intlNumber()
                }
            ]
        },
        responsive:true,
        layout: {
            topStart: {
                buttons: [
                    'copy', 'csv', 'excel'
                ]
            }
        }
    });
		
	$("table.dataTable tbody tr").each(function(i){
            $(this).click(function(){
                $('tr.selected-line').removeClass("selected-line");
                //Add class on line
                $(this).toggleClass("selected-line");
            });
    });
	
	//Menu trees
	const menu_subtrees = document.querySelectorAll(".subtree");
	menu_subtrees.forEach((subtree) => {
	  subtree.addEventListener("click", () => {
		subtree.classList.toggle("active");
		subtree.nextElementSibling.classList.toggle("active"); 
	  });
	});
	
});

